import * as React from 'react';
import {
    NullablePendingChangeCallback,
    PendingChangeCallback,
    useThrottlePendingChange,
} from './useThrottlePendingChange';

export const searchDelayTimeout = 300;
export const minCharactersToTriggerFilter = 1;

export function usePendingChange(
    enableFiltering: boolean | undefined,
    isOpened: React.MutableRefObject<boolean>,
    openDropDownCallback: () => void,
    onFilterItems: PendingChangeCallback,
    onFilterBegin?: () => void
): NullablePendingChangeCallback {
    const invalidateChange = useThrottlePendingChange(
        onFilterItems,
        enableFiltering && isOpened.current ? searchDelayTimeout : null
    );
    const onPendingChangeCallback = React.useCallback<NullablePendingChangeCallback>(
        (value: string | null) => {
            if (!enableFiltering || value === null) {
                // cancel any pending timer so that we don't trigger filtering accidentally
                invalidateChange(null);
                return;
            }
            // if user types 1 character or more, we open the dropdown
            if (value.length >= minCharactersToTriggerFilter && !isOpened.current) {
                openDropDownCallback();
                onFilterBegin?.();
                onFilterItems(value);
            }
            invalidateChange(value);
        },
        [
            invalidateChange,
            enableFiltering,
            openDropDownCallback,
            isOpened,
            onFilterItems,
            onFilterBegin,
        ]
    );

    return onPendingChangeCallback;
}
